import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import PerfectScrollbar from "react-perfect-scrollbar";
import { LandingRoutes } from "@/routes";

const queryClient = new QueryClient();

const LandingLayout = () => {
  return (
    <main className="h-full w-full bg-white">
      <QueryClientProvider client={queryClient}>
        <PerfectScrollbar className="h-full w-full">
          <LandingRoutes />
        </PerfectScrollbar>
      </QueryClientProvider>
    </main>
  );
};

export default LandingLayout;
